import React from "react";
import { useTranslation } from "react-i18next";

// Images
import aboutImg from "../../images/team/MedicalLaboratoryBanner.png";
import team1 from "../../images/team/portrait-confident-male-doctor.jpg";
import team2 from "../../images/team/portrait-confident-male-doctor.jpg";
import team3 from "../../images/team/portrait-confident-male-doctor.jpg";
import team4 from "../../images/team/portrait-confident-male-doctor.jpg";

const team = [
  { name: "د. منى حسن", role: "أخصائية تحاليل طبية", image: team1 },
  { name: "د. خالد يوسف", role: "مدير المعمل", image: team2 },
  { name: "د. سارة علي", role: "أخصائية كيمياء حيوية", image: team3 },
  { name: "د. أحمد محمد", role: "استشاري تحاليل أمراض", image: team4 },
];

const About = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <div dir={isRTL ? "rtl" : "ltr"} className="bg-white">
      {/* ===== Banner/Header ===== */}
      <header
        className="relative w-full h-[200px] md:h-[200px] flex flex-col justify-center items-center text-center text-white"
        style={{
          backgroundImage: `url(${aboutImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/60"></div>

        {/* Header Text */}
        <div className="relative z-10 px-4">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4 inline-block">
            {t("about.title")}
            <span className="block w-32 h-1 bg-secondColor mx-auto mt-3 rounded-full"></span>
          </h1>
          <h2 className="text-lg md:text-xl font-medium max-w-2xl mx-auto">
            {t("about.description")}
          </h2>
        </div>
      </header>

      {/* ===== About Section ===== */}
      <section className="py-24">
        <div className="container mx-auto px-6  gap-16 items-center">
          {/* Content */}
          <div>
            <h2 className="text-3xl font-bold text-primeColor-600 mb-6 relative inline-block">
              {t("about.story.title")}
              <span className="block w-12 h-1 bg-secondColor mt-2 rounded-full" />
            </h2>
            <p className="text-gray-600 leading-relaxed mb-10">
              {t("about.story.text")}
            </p>

            {/* Info Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Vision */}
              <div className="p-6 rounded-2xl bg-primeColor-50 border border-primeColor-100 shadow-sm hover:shadow-md transition">
                <h4 className="font-semibold text-primeColor-600 mb-2">
                  {t("about.vision.title")}
                </h4>
                <p className="text-sm text-gray-600">{t("about.vision.text")}</p>
              </div>
              {/* Mission */}
              <div className="p-6 rounded-2xl bg-primeColor-50 border border-primeColor-100 shadow-sm hover:shadow-md transition">
                <h4 className="font-semibold text-primeColor-600 mb-2">
                  {t("about.mission.title")}
                </h4>
                <p className="text-sm text-gray-600">{t("about.mission.text")}</p>
              </div>
              {/* Values */}
              <div className="p-6 rounded-2xl bg-primeColor-50 border border-primeColor-100 md:col-span-2 shadow-sm hover:shadow-md transition">
                <h4 className="font-semibold text-primeColor-600 mb-2">
                  {t("about.values.title")}
                </h4>
                <p className="text-sm text-gray-600">{t("about.values.text")}</p>
              </div>
            </div>
          </div>
        </div>
      </section>


    </div>
  );
};

export default About;
